import { i as p, B as x, x as f, u as O, E as C, r as L } from "../separate-component-helper-chunks/abstract-base-CdeHT0x1.js";
import { t as _ } from "../separate-component-helper-chunks/index.esm-D5sH112M.js";
import { B as u } from "../separate-component-helper-chunks/button-base-590OUKaH.js";
import { E as a } from "../separate-component-helper-chunks/events-CMiHMbSn.js";
import { a as v } from "../separate-component-helper-chunks/motion-Dkz--Os4.js";
import { A as S } from "../separate-component-helper-chunks/arrow-control-LD0pCOUG.js";
import { m as y, p as d, d as B, a as T } from "../separate-component-helper-chunks/lifecycle-decorators-VlFt_asj.js";
import { m as F } from "../separate-component-helper-chunks/mixin-DsSIi_3b.js";
import { b as k } from "../separate-component-helper-chunks/motion-primitive-DtG3H5TJ.js";
import { O as z } from "../separate-component-helper-chunks/opens-by-D2RgK0CJ.js";
import { P as K } from "../separate-component-helper-chunks/popup-CW2agM90.js";
import { b as P, a as D } from "../separate-component-helper-chunks/query-assigned-DiX8lRAH.js";
import { s as A } from "../separate-component-helper-chunks/scrollableRegion-04c2vFSL.js";
import { s as E } from "../separate-component-helper-chunks/showIfUsed-DHyCbsIU.js";
import { C as b, B as M } from "../separate-component-helper-chunks/icon-button-PZmQvhbY.js";
var w = /* @__PURE__ */ ((n) => (n.Anchor = "a", n.Button = "button", n.BeaconButton = '[beacon-tag-name="beacon-button"]', n.BeaconIconButton = '[beacon-tag-name="beacon-icon-button"]', n.tabIndex = '[tabindex]:not([tabindex="-1"])', n))(w || {});
function N(n) {
  class e extends n {
    constructor() {
      super(...arguments), this._firstFocusableElement = null, this._lastFocusableElement = null, this._triggerElement = null, this._nextFocusableElement = null, this.handleFirstFocusableKeydown = (o) => {
        this.triggerElement && this.forwardFocusToPrevious(o, this.triggerElement);
      }, this.handleLastFocusableKeydown = (o) => {
        this.nextFocusableElement && this.forwardFocusToNext(o, this.nextFocusableElement);
      }, this.handleNextFocusableKeydown = (o) => {
        this.lastFocusableElement && this.forwardFocusToPrevious(o, this.lastFocusableElement);
      }, this.handleTriggerKeydown = (o) => {
        this.firstFocusableElement && this.forwardFocusToNext(o, this.firstFocusableElement);
      };
    }
    get firstFocusableElement() {
      return this._firstFocusableElement;
    }
    set firstFocusableElement(o) {
      this.firstFocusableElement && this.firstFocusableElement.removeEventListener(
        a.KEYDOWN,
        this.handleFirstFocusableKeydown
      ), this._firstFocusableElement = o;
    }
    get lastFocusableElement() {
      return this._lastFocusableElement;
    }
    set lastFocusableElement(o) {
      this.lastFocusableElement && this.lastFocusableElement.removeEventListener(
        a.KEYDOWN,
        this.handleLastFocusableKeydown
      ), this._lastFocusableElement = o;
    }
    get triggerElement() {
      return this._triggerElement;
    }
    set triggerElement(o) {
      this.triggerElement && this.triggerElement.removeEventListener(
        a.KEYDOWN,
        this.handleTriggerKeydown
      ), this._triggerElement = o;
    }
    get nextFocusableElement() {
      return this._nextFocusableElement;
    }
    set nextFocusableElement(o) {
      this.nextFocusableElement && this.nextFocusableElement.removeEventListener(
        a.KEYDOWN,
        this.handleNextFocusableKeydown
      ), this._nextFocusableElement = o;
    }
    internalFocusableElements() {
      return Array.from(
        this.querySelectorAll(this.generateFocusableElementsSelector())
      );
    }
    forwardFocusToNext(o, s) {
      o.key === "Tab" && !o.shiftKey && (o.preventDefault(), s.focus());
    }
    forwardFocusToPrevious(o, s) {
      o.key === "Tab" && o.shiftKey && (o.preventDefault(), s.focus());
    }
    /**
     * Callback to initialize the focusable elements within the overlay
     * and set the first and last focusable elements for focus forwarding.
     */
    initializeInternalFocusableElements() {
    }
    /**
     * Callback to initialize the focusable elements outside of the overlay
     * and set the trigger element and next focusable element for focus forwarding.
     * @returns
     */
    initializeExternalFocusableElements() {
    }
    attachFocusableElementListeners() {
      this.firstFocusableElement && this.firstFocusableElement.addEventListener(
        a.KEYDOWN,
        this.handleFirstFocusableKeydown
      ), this.lastFocusableElement && this.lastFocusableElement.addEventListener(
        a.KEYDOWN,
        this.handleLastFocusableKeydown
      ), this.nextFocusableElement && this.nextFocusableElement.addEventListener(
        a.KEYDOWN,
        this.handleNextFocusableKeydown
      ), this.triggerElement && this.triggerElement.addEventListener(
        a.KEYDOWN,
        this.handleTriggerKeydown
      );
    }
    removeFocusableElementListeners() {
      this.firstFocusableElement && this.firstFocusableElement.removeEventListener(
        a.KEYDOWN,
        this.handleFirstFocusableKeydown
      ), this.lastFocusableElement && this.lastFocusableElement.removeEventListener(
        a.KEYDOWN,
        this.handleLastFocusableKeydown
      ), this.nextFocusableElement && this.nextFocusableElement.removeEventListener(
        a.KEYDOWN,
        this.handleNextFocusableKeydown
      ), this.triggerElement && this.triggerElement.removeEventListener(
        a.KEYDOWN,
        this.handleTriggerKeydown
      );
    }
    /**
     * Queries the closest shadowRoot to the popover, if it exists,
     * or the document if the popover is at the document level, and returns the first matching element.
     * Note that this does not cross different shadowDOM boundaries, and logic is dependent upon being
     * within the same lightDOM or shadowDOM contexts.
     * @param selector
     * @returns The first found element or null
     */
    DOMContextQuerySelector(o, s = this.getClosestHost()) {
      return s ? s.shadowRoot.querySelector(
        o
      ) : document.querySelector(o);
    }
    /**
     * Queries the closest shadowRoot to the popover, if it exists,
     * or the document if the popover is at the document level, and returns all matching
     * @param selector
     * @returns A list of elements that match the selector, or undefined if none are found.
     */
    DOMContextQuerySelectorAll(o, s = this.getClosestHost()) {
      return s ? s.shadowRoot.querySelectorAll(o) : document.querySelectorAll(o);
    }
    generateFocusableElementsSelector() {
      return `:is(${Object.values(w).join(", ")})`;
    }
    /**
     * Returns a focusable element that follows the selector in the DOM as a sibling,
     * also includes focusable elements nested within a container, which are not direct siblings.
     * @param selector
     * @returns
     */
    siblingFocusableElements(o) {
      const s = `${o} ~ ${this.generateFocusableElementsSelector()}`, i = `:has(${o}) ~ :has(${this.generateFocusableElementsSelector()}) ${this.generateFocusableElementsSelector()}`;
      return {
        directSibling: this.DOMContextQuerySelector(
          s
        ),
        indirectSibling: this.DOMContextQuerySelector(
          i
        )
      };
    }
  }
  return e;
}
var R = Object.getOwnPropertyDescriptor, $ = (n, e, t, o) => {
  for (var s = o > 1 ? void 0 : o ? R(e, t) : e, i = n.length - 1, r; i >= 0; i--)
    (r = n[i]) && (s = r(s) || s);
  return s;
};
function I(n) {
  let e = class extends n {
    extendFocus(t) {
      if (t) {
        const o = t.focus.bind(t);
        t.focus = function(s) {
          s != null && s.override && (t.classList.add("skip-focus-override"), t.addEventListener(
            "blur",
            () => {
              t.classList.remove("skip-focus-override");
            },
            { once: !0 }
          )), o(s);
        };
      } else
        console.log("Element is null");
    }
    overrideFocus(t) {
      t.forEach((o) => {
        this.extendFocus(o);
      });
    }
  };
  return e = $([
    y("FocusOptions")
  ], e), e;
}
function j(n, e = "keys") {
  if (!n) return;
  let t;
  switch (e) {
    case "entries":
      t = n.entries().next().value;
      break;
    case "values":
      t = n.values().next().value;
      break;
    case "keys":
    default:
      t = n.keys().next().value;
  }
  return t;
}
const H = p`[beacon-tag-name=beacon-popover] :is(h1,h2,h3,h4,h5,h6,p,ul,ol,blockquote){max-inline-size:85cqi}[beacon-tag-name=beacon-popover] :is(h1,h2,h3,h4,h5,h6){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-200);margin:0}[beacon-tag-name=beacon-popover]>:is(*):not([beacon-tag-name=beacon-menu]){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);margin:0;padding:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-popover] :is([slot=action-zone]){padding:0}[beacon-tag-name=beacon-popover]:not(:has([slot=action-zone])){--bottom-padding: var(--beacon-system-space-micro-jumbo)}[beacon-tag-name=beacon-popover] .media{inline-size:100%;max-block-size:20cqb;object-fit:cover;padding:var(--beacon-system-space-cell-contained)}`, W = p`@media (prefers-reduced-motion: no-preference){:host([motion-state=enabled]){transition-duration:var(--beacon-reference-motion-duration-3);transition-property:opacity;transition-timing-function:var(--popover-transition-timing-function, var(--beacon-system-motion-easing-decelerate-standard-1))}:host([motion-state=enabled]:not([open])){opacity:0}:host([motion-state=enabled][open]){opacity:1}:host([motion-state=enabled][open][closing]){--popover-transition-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1);opacity:0}}`;
var Y = Object.getOwnPropertyDescriptor, q = (n, e, t, o) => {
  for (var s = o > 1 ? void 0 : o ? Y(e, t) : e, i = n.length - 1, r; i >= 0; i--)
    (r = n[i]) && (s = r(s) || s);
  return s;
};
function Q(n) {
  let e = class extends n {
    static get PopoverMotionStyles() {
      return [W];
    }
  };
  return e = q([
    y("PopoverMotion")
  ], e), e;
}
const G = p`:host{container-type:inline-size;inline-size:100%;max-inline-size:var(--popover-max-inline-size, 17rem);min-inline-size:var(--popover-min-inline-size, 14rem);padding:initial;filter:drop-shadow(0rem 0rem var(--beacon-reference-space-1) var(--beacon-reference-palette-grayscale-shadow-1));--bottom-padding: 0}.popover{display:grid;grid-template-rows:1fr auto;max-block-size:400px}.header{inset-block-start:var(--beacon-reference-space-3);inset-inline-end:var(--beacon-reference-space-3);position:absolute}.body{overflow-y:auto;padding-inline:var(--beacon-system-space-micro-jumbo);padding-block-start:var(--beacon-system-space-micro-jumbo);padding-block-end:var(--bottom-padding);scrollbar-color:var(--beacon-component-scrollbar-color-background-thumb) var(--beacon-component-scrollbar-color-background-track);scrollbar-gutter:stable;scrollbar-width:thin}.footer{padding-block-end:var(--beacon-system-space-micro-jumbo);margin-block-start:var(--beacon-system-space-organism-normal);padding-inline:var(--beacon-system-space-micro-jumbo)}.action-zone{display:flex;gap:var(--beacon-system-space-micro-jumbo);justify-content:end;padding:var(--beacon-system-space-cell-contained)}.arrow{background-color:initial;display:flex;block-size:var(--beacon-reference-space-4);inline-size:var(--beacon-reference-space-8);--arrow-inline-size: var(--beacon-reference-space-8);--arrow-block-size: var(--beacon-reference-space-4);--mask-block-size: 8px;--drop-shadow-filter-radius: var(--beacon-reference-space-1);--mask-inline-size: calc(var(--arrow-inline-size) + calc(4 * var(--drop-shadow-filter-radius)))}.arrow[data-side=left]{transform:rotate(90deg)}.arrow[data-side=right]{transform:rotate(-90deg)}.arrow[data-side=top]{transform:rotate(180deg)}.arrow .arrow-vector{background-color:initial;position:absolute;block-size:var(--arrow-block-size);fill:var(--beacon-system-color-background-1);inline-size:var(--arrow-inline-size);bottom:-1px}@media (width >= 640px){:host{--popover-max-inline-size: 17.5rem;--popover-min-inline-size: 11.38rem}}@media (width >= 960px){:host{--popover-max-inline-size: 21.19rem;--popover-min-inline-size: 12.12rem}}@media (width >= 1280px){:host{--popover-max-inline-size: 29.56rem;--popover-min-inline-size: 17.06rem}}`;
var V = Object.defineProperty, Z = Object.getOwnPropertyDescriptor, c = (n, e, t, o) => {
  for (var s = o > 1 ? void 0 : o ? Z(e, t) : e, i = n.length - 1, r; i >= 0; i--)
    (r = n[i]) && (s = (o ? r(e, t, s) : r(s)) || s);
  return o && s && V(e, t, s), s;
};
class U extends F(x).with(
  I,
  N,
  S
) {
}
const h = class h extends F(U).with(
  Q,
  k,
  K,
  z
) {
  constructor() {
    super(...arguments), this.beaconTagName = b.beaconTagName, this.hasCloseButton = !0, this.handleKeydown = (e) => {
      e.isTrusted && this.slottedMenu && this.handleArrowControlKeydown(
        e,
        this.getArrowControlElements(),
        "vertical",
        (t) => {
          t == null || t.focus();
        }
      );
    }, this.show = (e) => {
      this.attachPopoverPageListener(), !this.prefersReducedMotion && this.motionState === v.ENABLED ? (this.closing = !1, this.showCallback(e)) : this.showCallback(e);
    }, this.handleCloseOnClickOut = (e) => {
      var o, s;
      const { isTrusted: t } = e;
      this.triggerElement && t && !((o = e == null ? void 0 : e.composedPath()) != null && o.includes(this)) && !((s = e == null ? void 0 : e.composedPath()) != null && s.includes(this.triggerElement)) && this.open && this.hide();
    }, this.hide = (e) => {
      !this.prefersReducedMotion && this.motionState === v.ENABLED ? this.closing = !0 : this.hideCallback(e);
    }, this.onFocusOut = (e) => {
      var o;
      const { relatedTarget: t } = e;
      this.open && !this.contains(t) && !((o = this.shadowRoot) != null && o.contains(t)) && (this.popupTimeout = setTimeout(() => {
        this.hide();
      }, 200));
    }, this.closeOnEscape = (e) => {
      var t;
      e.key === "Escape" && this.open && (this.hide(e), (t = this.triggerElement) == null || t.focus({
        override: !0
      }));
    }, this.onCloseButtonKeyPress = (e) => {
      var t;
      (e.key === "Enter" || e.code === "Space") && !this.closing && ((t = this.triggerElement) == null || t.focus({
        override: !0
      }));
    };
  }
  static get styles() {
    return [super.styles, this.popupStyles, this.PopoverMotionStyles, G];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, H];
  }
  getArrowControlElements() {
    return [this.closeButton, ...this.internalFocusableElements()];
  }
  attachArrowControlKeyboardListeners() {
    this.slottedMenu && this.getArrowControlElements().forEach((e) => {
      e.addEventListener(a.KEYDOWN, this.handleKeydown);
    });
  }
  runOpensBySetup() {
    this.opensByElements.forEach((e, t) => {
      t instanceof u && t.addEventListener("beacon-event-click", this.toggle), t instanceof u || t.addEventListener("click", this.toggle);
    });
  }
  runOpensByClean() {
    this.opensByElements.forEach((e, t) => {
      (t instanceof HTMLButtonElement || t instanceof HTMLInputElement) && t.removeEventListener("click", this.toggle), t instanceof u && t.removeEventListener("beacon-event-click", this.toggle);
    });
  }
  _renderArrowHTML() {
    return f`<div class="arrow">
      <svg
        aria-hidden="true"
        width="24"
        height="12"
        viewBox="0 0 24 12"
        xmlns="http://www.w3.org/2000/svg"
        class="arrow-vector">
        <path d="M24 12L12 0L0 12H24Z" />
      </svg>
    </div>`;
  }
  getOffset(e) {
    return e.offsetHeight;
  }
  getStaticSideArrowOffset(e, t) {
    return `-${t === "bottom" || t === "top" ? e.offsetHeight : e.offsetHeight + 8}px`;
  }
  setAriaExpanded() {
    var e;
    this._activeTrigger instanceof u ? this._activeTrigger.updateComplete.then(() => {
      var t;
      (t = this._activeTrigger.button) == null || t.setAttribute(
        "aria-expanded",
        String(this.open)
      );
    }) : (e = this._activeTrigger) == null || e.setAttribute("aria-expanded", String(this.open));
  }
  focusOnTrigger() {
    var e;
    (e = this._activeTrigger) == null || e.focus({ override: !0 });
  }
  focusOnCloseButton() {
    setTimeout(() => {
      var e;
      (e = this.closeButton) == null || e.focus({ override: !0 });
    }, 0);
  }
  initializeExternalFocusableElements() {
    this.triggerElement = this._activeTrigger;
  }
  initializeInternalFocusableElements() {
    var t, o;
    const e = this.internalFocusableElements();
    this.lastFocusableElement = (t = e[e.length - 1]) != null ? t : this.closeButton, this.firstFocusableElement = (o = this.closeButton) != null ? o : e[0];
  }
  runOnStart() {
    this.setAriaExpanded(), this.initializeInternalFocusableElements(), this.initializeExternalFocusableElements(), this.attachFocusableElementListeners(), this.overrideFocusableElements(), this.focusOnCloseButton(), this.findNextFocusableElement();
  }
  getShadowRootHost(e) {
    const t = e.getRootNode();
    return t instanceof ShadowRoot ? t.host : null;
  }
  isInShadowDOM(e) {
    return e.getRootNode() instanceof ShadowRoot;
  }
  /**
   * Tabbable will find all the elements from host and which can be nested through shadowDOM
   * This method is to filter out those elements and find the next focusable element
   */
  findNextFocusableElement() {
    var i;
    const o = _(
      (i = this.getShadowRootHost(this.triggerElement)) != null ? i : document.body,
      {
        getShadowRoot: !0,
        includeContainer: !0
      }
    ).filter((r) => {
      const m = this.getShadowRootHost(r);
      let g;
      return m && (g = this.getShadowRootHost(m)), !this.contains(m) && !this.contains(r) && g !== this;
    }).map((r) => this.getShadowRootHost(r) === this.triggerElement ? this.triggerElement : r), s = o.indexOf(this.triggerElement);
    s + 1 < o.length && (this.nextFocusableElement = o[s + 1]);
  }
  runOnStop() {
    this.setAriaExpanded(), this.removeFocusableElementListeners();
  }
  setAriaHasPopup() {
    var e, t;
    (e = this.slottedMenu) != null && e.length && ((t = this._activeTrigger) == null || t.setAttribute("aria-haspopup", "menu"));
  }
  attachPopoverPageListener() {
    document.addEventListener("click", this.handleCloseOnClickOut);
  }
  removePopoverPageListener() {
    document.removeEventListener("click", this.handleCloseOnClickOut);
  }
  closingAnimationCallback() {
    this.hideCallback();
  }
  renderCloseButton() {
    return O`
      <${this.getScopedTag("beacon-icon-button")} class="close-button" variant="tertiary" @beacon-event-click=${this.hide}
      @keypress=${this.onCloseButtonKeyPress}>
        <svg
          class="icon--close"
          slot="icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.4697 19.5303C18.7626 19.8232 19.2374 19.8232 19.5303 19.5303C19.8232 19.2374 19.8232 18.7626 19.5303 18.4697L13.0607 12L19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L12 10.9393L5.53033 4.46967C5.23744 4.17678 4.76256 4.17678 4.46967 4.46967C4.17678 4.76256 4.17678 5.23744 4.46967 5.53033L10.9393 12L4.46967 18.4697C4.17678 18.7626 4.17678 19.2374 4.46967 19.5303C4.76256 19.8232 5.23744 19.8232 5.53033 19.5303L12 13.0607L18.4697 19.5303Z"
            fill="#0063AD"
          />
        </svg>
        <slot name="close-button-text">Close</slot>
      </${this.getScopedTag("beacon-icon-button")}>
    `;
  }
  overrideFocusableElements() {
    this.overrideFocus([
      this.closeButton,
      ...this.internalFocusableElements(),
      this.triggerElement
    ]);
  }
  openByDefault() {
    this._activeTrigger = j(this.opensByElements), this.open && (this.show(), this.focusOnTrigger());
  }
  applyDatatMetricsLocation() {
    this.setAttribute(
      "data-metrics-location",
      b.DATA_METRICS_LOCATION_POPOVER
    );
  }
  async updateCloseButtonState() {
    var e;
    await this.updateComplete, (e = this.slottedMenu) != null && e.length && (this.hasCloseButton = !1);
  }
  render() {
    return f`
      <div class="popover" @focusout=${this.onFocusOut}>
        <div class="header">
          ${this.hasCloseButton ? this.renderCloseButton() : C}
        </div>
        <div class="body" tabindex=${A()}>
          <slot ${E({ useParent: !0 })}></slot>
        </div>
        <div class="footer">
          <div class="action-zone">
            <slot
              name="action-zone"
              ${E({ container: ".footer" })}></slot>
          </div>
        </div>
        ${this._renderArrowHTML()}
      </div>
    `;
  }
};
h.nestedComponents = [M], h.tagName = b.beaconTagName;
let l = h;
c([
  P(".close-button")
], l.prototype, "closeButton", 2);
c([
  L()
], l.prototype, "hasCloseButton", 2);
c([
  D({
    slot: "",
    selector: '[beacon-tag-name="beacon-menu"]'
  })
], l.prototype, "slottedMenu", 2);
c([
  d
], l.prototype, "attachArrowControlKeyboardListeners", 1);
c([
  d
], l.prototype, "setAriaHasPopup", 1);
c([
  B
], l.prototype, "removePopoverPageListener", 1);
c([
  d
], l.prototype, "openByDefault", 1);
c([
  T
], l.prototype, "applyDatatMetricsLocation", 1);
c([
  d
], l.prototype, "updateCloseButtonState", 1);
export {
  l as BeaconPopover
};
